import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utilitário padrão do shadcn/ui. Combina classes condicionais (clsx) e
 * resolve conflitos do Tailwind (twMerge) — ex: `cn('p-2', cond && 'p-4')`
 * resulta em `p-4` em vez das duas classes em conflito.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
